import React from 'react';
import { useTranslation } from 'react-i18next';
import { Category } from '../../types';
import { getCategoryIcon } from '../../utils/categoryIcons';

interface CategoryCardProps {
  category: Category;
  onClick?: () => void;
}

export const CategoryCard: React.FC<CategoryCardProps> = ({ category, onClick }) => {
  const { i18n } = useTranslation();

  const getCategoryName = () => {
    const lang = i18n.language || 'fr';
    return category.names?.[lang] || category.names?.['fr'] || category.slug || 'Catégorie';
  };

  return (
    <div
      onClick={onClick}
      className="bg-white border-2 border-gray-200 rounded-xl p-6 text-center hover:border-primary-500 hover:shadow-xl transition-all cursor-pointer group"
    >
      <div className="flex justify-center mb-4 group-hover:scale-110 transition-transform text-primary-600">
        {getCategoryIcon(category.slug, category.iconUrl, "w-12 h-12")}
      </div>
      <h3 className="font-semibold text-gray-900 group-hover:text-primary-600 transition-colors">
        {getCategoryName()}
      </h3>
    </div>
  );
};
